import React from 'react';
import { DropTarget } from 'react-dnd';
import DragSource from './DragSource';
import classNames from 'classnames';
import './styles.styl';
import PropTypes from 'prop-types';

const dropTarget = {
  drop(props, monitor) {
    let dropped = monitor.getItem();
    props.onDrop(dropped, props.name);
    return {
      name: props.name
    };
  }
};

const collect = connect => {
  return {
    connectDropTarget: connect.dropTarget()
  };
};

const dropTargetClasses = droppedItems => {
  return classNames(
    {
      'drop-zone--occupied': droppedItems && droppedItems.length > 0
    },
    'drop-zone'
  );
};

const DropItem = ({
  name,
  connectDropTarget,
  droppedItems,
  dropZoneMessage,
  hasValidated,
  correctInput,
  keyboardDND,
  dropZones,
  handleDrop,
  isFinalAttempt,
  visibleDropMenu
}) => {
  return (
    <div className="drop-zone-wrapper">
      <p className="drop-zone-wrapper__title">{name}</p>
      {connectDropTarget(
        <div className={dropTargetClasses(droppedItems)}>
          {droppedItems && droppedItems.length > 0 ? (
            droppedItems.map(item => {
              let correct = true;
              if (correctInput && correctInput.indexOf(item) === -1) {
                correct = false;
              }
              return (
                <DragSource
                  key={item}
                  item={item}
                  hasValidated={hasValidated}
                  correct={correct}
                  keyboardDND={keyboardDND}
                  dropZones={dropZones}
                  handleDrop={handleDrop}
                  visibleDropMenu={visibleDropMenu}
                  isFinalAttempt={isFinalAttempt}
                />
              );
            })
          ) : (
            <p className="drop-zone__empty-message">{dropZoneMessage}</p>
          )}
        </div>
      )}
    </div>
  );
};

DropItem.propTypes = {
  name: PropTypes.string.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  droppedItems: PropTypes.array,
  dropZoneMessage: PropTypes.string,
  hasValidated: PropTypes.bool.isRequired,
  correctInput: PropTypes.array,
  keyboardDND: PropTypes.func.isRequired,
  dropZones: PropTypes.array,
  handleDrop: PropTypes.func.isRequired,
  visibleDropMenu: PropTypes.string
};

export default DropTarget('DnD', dropTarget, collect)(DropItem);



// WEBPACK FOOTER //
// ../core/src/components/DragAndDrop/DropTarget.js